import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5 18.7129L17.7279 5.98497L19.1421 7.39918L6.41421 20.1271L5 18.7129Z"
        fill="var(--svg-color-main, black)"
      />
      <path
        d="M6.41431 5.98438L19.1422 18.7123L17.728 20.1265L5.00009 7.39859L6.41431 5.98438Z"
        fill="var(--svg-color-main, black)"
      />
    </svg>
  )
}
